<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :brands="brands"
            :all-product-groups="allProductGroups"
            :is-addon="isAddon"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductGroups/Form'

export default {
    name: 'ProductGroupCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        brands: {
            type: Array,
            default () {
                return []
            }
        },
        allProductGroups: {
            type: Array,
            default () {
                return []
            }
        },
        isAddon: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('products.product-groups.store'))
        }
    }
}
</script>
